/** Reveal legacy and new motion elements within a document or block preview. */
export function initScrollAnimations(scope = document) {
  if (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  const animatedElements = scope.querySelectorAll(
    '.rv, .rv-img, .draw, .plan, .fade-in, .ease-right, .ease-left, .ease-btm, .ease-top, [class*="flip-"]'
  );

  if (!animatedElements.length) {
    return;
  }

  const supportsTimeline = CSS.supports('animation-timeline: view()');
  document.body.classList.add('is-scroll-ready');

  if (!('IntersectionObserver' in window)) {
    animatedElements.forEach((el) => el.setAttribute('data-scroll', 'in'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-scroll', 'in');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1,
    }
  );

  animatedElements.forEach((el) => {
    if (el.dataset.scrollObserved) return;
    if (supportsTimeline && el.matches('.rv, .rv-img, .draw, .plan')) return;
    el.dataset.scrollObserved = 'true';
    el.setAttribute('data-scroll', '');
    observer.observe(el);
  });
}
